import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { atom_tourState } from "@app/shared/state/tour.atom";
import { useTranslation } from "react-i18next";

const PurchaseModalContent: React.FC = () => {
    const tourState = useRecoilValue(atom_tourState);
    const tourName = tourState?.title;
    const { t, i18n } = useTranslation();

    // Add your purchase modal content here
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 220,
                p: 3,
                gap: 2,
            }}
        >
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1, fontSize: '26px', textAlign: 'center' }}>
                {t('purchase_modal.title')} {tourName}
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, textAlign: 'center', fontSize: '20px' }}>
                {t('purchase_modal.description').split('\n').map((line, i) => (
                    <React.Fragment key={i}>
                        {line}
                        <br />
                    </React.Fragment>
                ))}
            </Typography>
            <Button
                variant="contained"
                color="primary"
                href={tourState?.config?.purchase_link || '#'}
                // target="_blank"
                sx={{ minWidth: 160, fontWeight: 600, mb: 1 }}
            >
                {t('purchase_modal.purchase_button')}
            </Button>
        </Box>
    );
};

export default PurchaseModalContent;